import { temAcesso } from '@/shared/auth/temAcesso'

const Pagamentos = () => import('./Pagamentos.vue')
const Pagamento = () => import('./Pagamento.vue')
const PagamentoAssociarConsultorias = () =>
    import('./PagamentoAssociarConsultorias.vue')

export default {
    path: 'pagamentos',
    name: 'AppSebrae_Consultorias_Fornecedor_Pagamentos',
    component: Pagamentos,
    beforeEnter: (to, from, next) => {
        if (temAcesso('APPSE-FORN-PAG-00')) {
            next()
        }
    },
    children: [
        {
            path: ':pagamentoId',
            name: 'AppSebrae_Consultorias_Fornecedor_Pagamentos_Detalhar',
            component: Pagamento,
            beforeEnter: (to, from, next) => {
                if (temAcesso('APPSE-FORN-PAG-02')) {
                    next()
                }
            },
            children: [
                {
                    path: 'associarconsultorias',
                    name:
                        'AppSebrae_Consultorias_Fornecedor_Pagamentos_AssociarConsultorias',
                    component: PagamentoAssociarConsultorias,
                    beforeEnter: (to, from, next) => {
                        if (temAcesso('APPSE-FORN-PAG-03')) {
                            next()
                        }
                    }
                }
            ]
        }
    ]
}
